export const CABINET_ROUTES = {
  DASHBOARD: "/cabinet-dashboard",
};
